export default __webpack_public_path__ + "static/media/Thumb-6.998f9f48.png";